// ── Run Stats + warning labels for code-mode Case When (pure) ────────────

// {mode:"code", total, outputs:[{name, blank, kept, values:[{value,count}]}]}
// -> a table model, or null for any other stats shape (builder stats are
// rendered by the existing branch table).
export function mapCodeStats(stats) {
  if (!stats || stats.mode !== 'code' || !Array.isArray(stats.outputs)) return null;
  const total = Number.isFinite(stats.total) ? stats.total : 0;
  return {
    total,
    outputs: stats.outputs.map(o => ({
      name: String(o.name),
      blank: o.blank ?? 0,
      kept: o.kept ?? 0,
      filled: Math.max(0, total - (o.blank ?? 0)),
      top: (o.values || []).slice(0, 10).map(v => ({ value: v.value, count: v.count })),
    })),
  };
}

// Short labels for the warnings panel (code stays visible next to it).
export const WARNING_LABELS = {
  EXPR_ROW_ERROR: 'Code error on some rows',
  EXPR_BAD_RETURN: 'Returned a value that can’t be stored',
  EXPR_NO_RETURN: 'Code returned nothing',
  EXPR_UNKNOWN_OUTPUT: 'Returned an unknown output name',
  EXPR_NEEDS_REVIEW: 'Imported code needs review',
  EXPR_NON_BOOLEAN: 'Case code didn’t return true/false',
  EXPR_UNKNOWN_OUTPUT_KEY: 'Returned key isn’t an output column',
  EXPR_MISSING_OUTPUT_KEY: 'An output column is never returned',
};

export function warningLabel(code) {
  return WARNING_LABELS[code] || null;
}
